module.exports = __webpack_public_path__ + "img/thumbnail-marquee-shop.4ac6f926.webp";